import { GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { styled } from '@mui/system';
import { SnackbarProvider } from 'notistack';
import type { SnackbarProviderProps } from 'notistack';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import { WHITE } from 'reservations/brand/helpers/v1/palette';
import { getTheme } from 'reservations/brand/helpers/v1/theme';
import useBrandData from 'reservations/brand/hooks/useBrandData';

type MuiThemeProviderProps = {
  children?: React.ReactNode;
};

const DEFAULT_SNACKBAR_PROVIDER_PROPS: Partial<SnackbarProviderProps> = {
  maxSnack: 1,
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'top'
  },
  preventDuplicate: true,
  hideIconVariant: true,
  dense: true
};

const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  '&.notistack-MuiContent-error': {
    backgroundColor: WHITE,
    color: 'black',
    fontFamily: 'Inter'
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: WHITE,
    color: theme.palette.soy.dark,
    fontFamily: 'Inter'
  }
}));

function MuiThemeProvider({ children }: MuiThemeProviderProps) {
  const { primary_color: primaryColor } = useAccount();
  const { hasFeature, styles, fonts } = useBrandData();

  const theme = getTheme(hasFeature, primaryColor, styles, fonts);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{ '.clover-footer': { display: 'none' } }} />
      <StyledSnackbarProvider {...DEFAULT_SNACKBAR_PROVIDER_PROPS}>
        {children}
      </StyledSnackbarProvider>
    </ThemeProvider>
  );
}

export default MuiThemeProvider;
